import * as React from 'react';

import { compose } from 'redux';
import {
  isUBQ,
  selectShowUbqShutdownModal,
  setShowUbqShutdownModal,
  useBubMigration,
  withTextLocalizer,
} from 'getaway-data-layer';
import { WithCustomerSupport, WithTextLocalizer } from 'getaway-data-layer';
import UbqShutdownView from './UbqShutdownView';
import { useDispatch, useSelector } from 'react-redux';

type Props = WithTextLocalizer & WithCustomerSupport;

const UbqShutdownModal = ({ localize }: Props) => {
  const dispatch = useDispatch();
  const show = useSelector(selectShowUbqShutdownModal);

  const { onShutdownCTA, formattedUbqShutdownDate } = useBubMigration(
    isUBQ(),
    true
  );

  const onClose = () => {
    dispatch(setShowUbqShutdownModal(false));
  };

  return isUBQ() && show ? (
    <UbqShutdownView
      localize={localize}
      title={localize('ubq.shutdown.modal.title')}
      description={localize('ubq.shutdown.modal.desc')}
      ctaText={localize('ubq.shutdown.modal.cta', formattedUbqShutdownDate)}
      secondaryCTAText={localize('ubq.shutdown.modal.link')}
      onCTA={onShutdownCTA}
      onClose={onClose}
      onSecondaryCTA={onClose}
      showSecondaryCTA
      showClose={false}
    />
  ) : null;
};

const withRentalWalkThroughContainer: any = compose(withTextLocalizer);

export default withRentalWalkThroughContainer(UbqShutdownModal);
